import React from 'react';
import { Box } from '@material-ui/core';

const PublicLayout = ({ children }) => <Box>{children}</Box>;

export default PublicLayout;
